/* Other imports. */
import { articleCategories } from "@src/constants";

/**
 * Returns the slug of a given category codename.
 *
 * @param codename The category's codename.
 * @returns The category's slug.
 */
// eslint-disable-next-line import/prefer-default-export
export function getCategorySlug(codename: string) {
  const category = Object.values<any>(articleCategories).find(
    (object) => object.codename === codename,
  );

  return category ? category.slug : null;
}
